var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"form-indexes"},[_c('ul',{staticClass:"form-indexes__list"},_vm._l((_vm.titles),function(title,i){return _c('li',[_c('div',{class:{'form-indexes__index': true, 'form-indexes__index--active': i === _vm.index},domProps:{"textContent":_vm._s(i + 1)}}),_vm._v(" "),_c('div',{staticClass:"form-indexes__label",domProps:{"textContent":_vm._s(title)}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a835381","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/FormIndexes/FormIndexes.html
// module id = null
// module chunks = 